(function() {
    'use strict';
    
    // Simple function to hide quantity boxes for specific products
    function hideQuantityForTeamStoreProducts() {
        // Get all product items
        const productItems = document.querySelectorAll('.cd-product-item');
        
        productItems.forEach(item => {
            // Get the content div with product ID
            const contentDiv = item.querySelector('.cd-product-item-content');
            if (!contentDiv) return;
            
            // Check if this is a team store product (has multiple player options)
            const playerOptions = item.querySelectorAll('.cd-product-item-options');
            let playerCount = 0;
            
            playerOptions.forEach(option => {
                if (option.textContent.includes('Player-')) {
                    playerCount++;
                }
            });
            
            // If it has multiple player options (team store product)
            if (playerCount >= 3) {
                // Hide the quantity box
                const quantityBox = item.querySelector('.cd-number-input');
                const quantityContainer = item.querySelector('.cd-number-input-container');
                const quantityInput = item.querySelector('.cd-number-input-field');
                const quantityButtons = item.querySelectorAll('.cd-number-input-button');
                 
                if (quantityBox) {
                    quantityBox.style.display = 'none';
                    quantityBox.remove();
                }
                
                if (quantityInput) {
                    quantityInput.style.display = 'none';
                }
                
                
                quantityButtons.forEach(btn => {
                    btn.style.display = 'none';
                });
                
                // Add fixed quantity text
                /*
                const priceSection = item.querySelector('.wrapper-price-section');
                if (priceSection && !item.querySelector('.fixed-qty-badge')) {
                    const badge = document.createElement('span');
                    badge.className = 'fixed-qty-badge';
                    badge.textContent = 'Fixed Quantity';
                    badge.style.cssText = `
                        background: #4CAF50;
                        color: white;
                        font-size: 10px;
                        padding: 2px 6px;
                        border-radius: 3px;
                        margin-left: 8px;
                    `;
                    priceSection.appendChild(badge);
                }
                    */
            }
        });
    }
    
    // Run once when page loads
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            setTimeout(hideQuantityForTeamStoreProducts, 500);
        });
    } else {
        setTimeout(hideQuantityForTeamStoreProducts, 500);
    }
    
    // Run when cart drawer opens (simple click handler)
    document.addEventListener('click', function(e) {
        // Check if cart drawer button was clicked
        if (e.target.closest('[data-cart-drawer-toggle]') || 
            e.target.closest('.cart-icon') ||
            e.target.closest('.header-cart')) {
            
            setTimeout(hideQuantityForTeamStoreProducts, 800);
        }
    });
    
    // Simple interval check (runs only 3 times then stops)
    let checkCount = 0;
    const interval = setInterval(() => {
        hideQuantityForTeamStoreProducts();
        checkCount++;
        
        if (checkCount >= 3) {
            clearInterval(interval);
        }
    }, 1000);
    
    // Expose function globally for manual trigger if needed
    window.hideTeamStoreQuantities = hideQuantityForTeamStoreProducts;
    
})();